/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDateTime } from '../../models/local-date-time';
import { SensorPageDto } from '../../models/sensor-page-dto';

export interface GetAnalysisPageData$Params {
  fillMissingDates?: boolean;
  fromDate?: LocalDateTime;
  groupIdx?: Array<number>;
  harvestId: number;
  targetsDays?: number;
  targetsFromDays?: number;
}

export function getAnalysisPageData(http: HttpClient, rootUrl: string, params: GetAnalysisPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<SensorPageDto>> {
  const rb = new RequestBuilder(rootUrl, getAnalysisPageData.PATH, 'get');
  if (params) {
    rb.query('fillMissingDates', params.fillMissingDates, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('groupIdx', params.groupIdx, {});
    rb.query('harvestId', params.harvestId, {});
    rb.query('targetsDays', params.targetsDays, {});
    rb.query('targetsFromDays', params.targetsFromDays, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SensorPageDto>;
    })
  );
}

getAnalysisPageData.PATH = '/api/telemetry/analysis';
